/**
 * Logger utility for TaleCraft
 * Automatically disables console.log statements in production mode
 */

const isProduction = import.meta.env.PROD || import.meta.env.MODE === 'production';

export const logger = {
  log: (message?: any, ...optionalParams: any[]) => {
    if (!isProduction) {
      console.log(message, ...optionalParams);
    }
  },
  error: (message?: any, ...optionalParams: any[]) => {
    // Always log errors, even in production
    console.error(message, ...optionalParams);
  },
  warn: (message?: any, ...optionalParams: any[]) => {
    // Always log warnings, even in production
    console.warn(message, ...optionalParams);
  },
  info: (message?: any, ...optionalParams: any[]) => {
    if (!isProduction) {
      console.info(message, ...optionalParams);
    }
  },
  debug: (message?: any, ...optionalParams: any[]) => {
    if (!isProduction) {
      console.debug(message, ...optionalParams);
    }
  }
};